export type LoggerEvent = {
    name: string
}

export function logEvent(event: LoggerEvent) {
    const eventsPayload = {
        events: [
            {
                target: 'voltax_recirculation',
                type: 'widget_group_of_links',
                version: '1.0',
                event: event.name,
                domain: typeof window !== 'undefined' ? window.location.hostname : '',
                path: typeof window !== 'undefined' ? window.location.href : '',
            },
        ],
    }

    const url = 'https://eventer-widget.bqstreamer.com/tr'
    const payload = JSON.stringify(eventsPayload)

    if (typeof navigator !== 'undefined' && navigator.sendBeacon) {
        navigator.sendBeacon(url, payload)
    }
}
